(function () {
  'use strict';

  function initHeader(header) {
    var form = header.querySelector('[data-sp-header-search]');
    if (!form || form.dataset.spReady === 'true') return;
    form.dataset.spReady = 'true';

    var input = form.querySelector('.sp-header-search__input');
    var button = form.querySelector('[data-sp-search-button]');
    var results = form.querySelector('.sp-header-search__results');
    var suggestUrl = form.dataset.suggestUrl || '/search/suggest';
    var timer = 0;
    var controller = null;

    function setOpen(open) {
      form.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? 'Search' : 'Open search');
      input.setAttribute('aria-expanded', String(open && !results.hidden));
      if (!open) hideResults();
    }

    function hideResults() {
      results.hidden = true;
      results.replaceChildren();
      input.setAttribute('aria-expanded', 'false');
    }

    function addTextResult(item, kind) {
      var link = document.createElement('a');
      link.className = 'sp-search-result sp-search-result--text';
      link.href = item.url;
      link.setAttribute('role', 'option');
      link.textContent = item.title + (kind ? ' · ' + kind : '');
      results.appendChild(link);
    }

    function addProduct(product) {
      var link = document.createElement('a');
      link.className = 'sp-search-result';
      link.href = product.url;
      link.setAttribute('role', 'option');

      var image = document.createElement('img');
      image.className = 'sp-search-result__image';
      image.loading = 'lazy';
      image.alt = '';
      var imageData = product.featured_image || product.image;
      if (imageData) image.src = typeof imageData === 'string' ? imageData : imageData.url;

      var copy = document.createElement('span');
      copy.className = 'sp-search-result__copy';
      var title = document.createElement('span');
      title.className = 'sp-search-result__title';
      title.textContent = product.title;
      var meta = document.createElement('span');
      meta.className = 'sp-search-result__meta';
      meta.textContent = formatPrice(product.price) || product.type || 'Product';
      copy.append(title, meta);
      link.append(image, copy);
      results.appendChild(link);
    }

    function formatPrice(value) {
      if (value === undefined || value === null || value === '') return '';
      var amount = Number(value);
      if (!Number.isFinite(amount)) return String(value);
      var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (error) {
        return currency + ' ' + amount.toLocaleString();
      }
    }

    function renderResults(data, query) {
      results.replaceChildren();
      var found = data && data.resources && data.resources.results ? data.resources.results : {};
      var products = (found.products || []).slice(0, 5);
      var collections = (found.collections || []).slice(0, 2);
      var pages = (found.pages || []).slice(0, 2);

      products.forEach(addProduct);
      collections.forEach(function (item) { addTextResult(item, 'Collection'); });
      pages.forEach(function (item) { addTextResult(item, 'Page'); });

      if (!products.length && !collections.length && !pages.length) {
        var empty = document.createElement('div');
        empty.className = 'sp-search-empty';
        empty.textContent = 'No suggestions for “' + query + '”.';
        results.appendChild(empty);
      }

      var all = document.createElement('a');
      all.className = 'sp-search-result--all';
      all.href = form.action + '?q=' + encodeURIComponent(query);
      all.textContent = 'View all results';
      results.appendChild(all);
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function requestSuggestions(query) {
      if (controller) controller.abort();
      controller = new AbortController();
      var endpoint = suggestUrl + '.json?q=' + encodeURIComponent(query)
        + '&resources[type]=product,collection,page'
        + '&resources[limit]=9'
        + '&resources[options][unavailable_products]=hide';

      fetch(endpoint, { signal: controller.signal, headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search request failed');
          return response.json();
        })
        .then(function (data) {
          if (input.value.trim() === query) renderResults(data, query);
        })
        .catch(function (error) {
          if (error.name !== 'AbortError') hideResults();
        });
    }

    button.addEventListener('click', function () {
      if (!form.classList.contains('is-open')) {
        setOpen(true);
        window.requestAnimationFrame(function () { input.focus(); });
        return;
      }

      if (!input.value.trim()) {
        input.value = '';
        setOpen(false);
        button.focus();
        return;
      }

      form.requestSubmit();
    });

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      var query = input.value.trim();
      if (!query) {
        hideResults();
        return;
      }
      timer = window.setTimeout(function () { requestSuggestions(query); }, 180);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && input.value.trim()) {
        event.preventDefault();
        form.requestSubmit();
        return;
      }
      if (event.key === 'Escape') {
        input.value = '';
        setOpen(false);
        button.focus();
      }
    });

    form.addEventListener('submit', function (event) {
      if (!input.value.trim()) {
        event.preventDefault();
        setOpen(false);
        button.focus();
      }
    });

    document.addEventListener('pointerdown', function (event) {
      if (!form.contains(event.target)) hideResults();
    });

    document.addEventListener('cart:updated', updateCartCount);
    document.addEventListener('cart:refresh', updateCartCount);
    updateCartCount();
  }

  function updateCartCount() {
    var counts = document.querySelectorAll('[data-sp-header-cart-count]');
    if (!counts.length) return;
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) { return response.ok ? response.json() : Promise.reject(); })
      .then(function (cart) {
        var itemCount = Number(cart.item_count) || 0;
        counts.forEach(function (count) {
          count.textContent = itemCount;
          count.hidden = itemCount < 1;
          var link = count.closest('.sp-header-bag-icon');
          if (link) link.setAttribute('aria-label', 'Bag, ' + itemCount + ' ' + (itemCount === 1 ? 'item' : 'items'));
        });
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll('[data-sp-refined-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
